<script>
  export default {
    name: 'kayak-list-item',
    props: ['item'],
    computed: {
      imagePath () {
        return require("@/assets/images/uploads/kayaks/" + this.item.slug + ".png")
      },
      getKayakDetailPath () {
        return "/kayaks/" + this.item.slug;
      }
    }
  }
</script>
<template>
  <b-col
    md="6"
    class="mt-5">
    <b-card
      header-bg-variant="dark"
      header-text-variant="white"
      no-body>
      <template #header>
        <h5
          class="mb-0 uppercase">
          {{ item.name }}
        </h5>
      </template>
      <b-card-body>
        <b-card-img
          :src="imagePath">
        </b-card-img>
        <b-list-group
          flush
          class="mt-4">
          <b-list-group-item
            class="d-flex justify-content-between align-items-center">
            <span
              class="entry">
              STATO
            </span>
            <b-badge
              variant="light"
              pill>
              NUOVO CON DIFETTO
            </b-badge>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center">
            <span
              class="entry">
              {{ item.material }}
            </span>
            <div>
              <b-badge
                variant="light"
                pill>
                  {{ item.discountedPricing + " " + item.currencySymbol }}
              </b-badge>
              <b-badge
                variant="light"
                pill>
                <span
                  style="text-decoration: line-through;">
                  {{ item.pricing + " " + item.currencySymbol }}
                </span>
              </b-badge>
            </div>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center">
            <span
              class="entry">
              COLORE
            </span>
            <div class="single-color">
              <div
                class="ral-code">
                <b-badge
                  variant="light"
                  pill>
                  RAL {{ item.color.ralCode }}
                </b-badge>
              </div>
              <div
                class="circle-shape"
                :style="{ backgroundColor: '#' + item.color.hexCode }"/>
            </div>
          </b-list-group-item>
        </b-list-group>
        <b-card-text
          class="description mt-4">
          {{ item.defectDescription }}
        </b-card-text>
        <b-button
          variant="outline-dark"
          class="mt-4"
          style="float: right;"
          :to=getKayakDetailPath>
          Scopri il modello
          <b-icon
            icon="arrow-right-short"/>
        </b-button>
      </b-card-body>
    </b-card>
  </b-col>
</template>
<style scoped>
  .description {
    line-height: 1.5em;
    min-height: 3em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  .entry {
    text-transform: uppercase;
  }
  .single-color {
    /* width: fit-content; */
    display: table;
  }
  .ral-code {
    display: table-cell;
    vertical-align: middle;
    line-height: 0.5em;
  }
  .circle-shape {
    margin-left: 0.5em;
    height: 1.2rem;
    width: 1.2rem;
  }
</style>